import React from 'react';
import loadable from '@loadable/component';
import { Grid, GridCol } from '@naf/grid';
import { Text, TextVariant } from '@naf/text';
import { LayoutWithMainContent } from '@components/layout/Layout';
import useSelector from '@redux/typedHooks';
import S from '@styles/bilguide/StyledBilGuide';
import CarSearchSort from '@components/bilguide/carSearchSort/CarSearchSort';
import CarList from '@components/bilguide/carlist/CarList';
import ActiveFilterChips from '@components/bilguide/activeFilterChips/ActiveFilterChips';
import { useWindowLocation } from '@hooks/Window/useWindowLocation';
import { InternalSearchCardType } from '@components/layout/InternalSearchMetaData';

const CarFilter = loadable(() => import('@components/bilguide/carfilter/CarFilter'));

const ElbilGuide = () => {
  const carsArray = useSelector((state) => state.cars.data);
  const allFilters = useSelector((state) => state.carFilter.allFilters);
  const windowPath = useWindowLocation();

  return (
    <LayoutWithMainContent
      title="Elbiler i Norge - elbilguiden"
      description="To ganger i året tester vi rekkevidden og ladehastigheten til elbilene på det norske markedet. Her får du oversikt over alle bilene som er testet."
      url={windowPath}
      gtmArgs={{
        page_type: 'ElectricCarsPage',
        pageCategory: 'Elbilguiden',
        contentId: '',
      }}
      internalSearchMetaData={{ cardType: InternalSearchCardType.CategoryApp }}
    >
      {carsArray.length === 0 ? (
        <h1
          style={{
            minHeight: '600px',
          }}
        >
          Henter bilene...
        </h1>
      ) : (
        <S.Wrapper>
          <Grid>
            <GridCol s="12" m="12" l="12" xl="12">
              <Text tag="h1" variant={TextVariant.Header1}>
                Elbilguiden
              </Text>
              <S.IngressWrapper>
                <Text tag="p" variant={TextVariant.Ingress}>
                  To ganger i året tester vi rekkevidden og ladehastigheten til elbilene på det norske markedet. Her får
                  du oversikt over alle bilene som er testet.
                </Text>
              </S.IngressWrapper>
              <CarSearchSort />
            </GridCol>
            <GridCol s="12" m="12" l="4" xl="4">
              <S.CarFilterWrapper>{allFilters && <CarFilter />}</S.CarFilterWrapper>
            </GridCol>
            <GridCol s="12" m="12" l="8" xl="8">
              <S.CarListWrapper>
                <ActiveFilterChips />
                <CarList />
              </S.CarListWrapper>
            </GridCol>
          </Grid>
        </S.Wrapper>
      )}
    </LayoutWithMainContent>
  );
};

export default ElbilGuide;
